import styled from 'styled-components';

export const HeroSection = styled.section`
padding-top: 80px;
  width: 100%;
  height: 100vh;
  position: relative; 
  z-index: 1;          
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${(props) =>
  `linear-gradient(rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6)), url(${props.bgImage})`};
  background-size: cover;
  background-position: center;
  color: #fff;
  text-align: center;
  padding: 0 1rem;
`;

export const ContentWrapper = styled.div`
  max-width: 700px;

  h1 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
    line-height: 1.2;
  }

  p {
    font-size: 1.25rem;
    line-height: 1.6;
    margin-bottom: 2rem;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;
